import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { ContasComponent } from './contas.component';
import { ContasRoutingModule } from "./contas-routing.module";
import { ContaContabilModule } from "./conta-contabil/conta-contabil.module";

@NgModule({
    imports: [
        SharedModule,
        ContaContabilModule,
        ContasRoutingModule
    ],
    declarations: [ContasComponent]
})
export class ContasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/contas.module.ts
 **/